/**
 * Context definition for Daily Reports WebSocket
 */
import { createContext } from 'react';

interface DailyReportEvent {
  event: string;
  report_id?: number;
  employee_name?: string;
  [key: string]: unknown;
}

export interface DailyReportsWebSocketContextValue {
  unreadCount: number;
  connectionState: 'connecting' | 'open' | 'closed' | 'error';
  subscribe: (callback: (event: DailyReportEvent) => void) => () => void;
  refreshCount: () => Promise<void>;
}

export const DailyReportsWebSocketContext = createContext<DailyReportsWebSocketContextValue | null>(null);
